import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { MYCONVERSIONCHART_INIT_LOADING, MYCONVERSIONCHART_INIT_SUCCESS, MYCONVERSIONCHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  myConversionChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {

}

const actions = {
  async initMyConversionChart({ commit, state }, data) {
    commit(MYCONVERSIONCHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.myConversionChart
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to),
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(MYCONVERSIONCHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYCONVERSIONCHART_INIT_FAIL)
      }
    } else {
      commit(MYCONVERSIONCHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYCONVERSIONCHART_INIT_LOADING](state) {
    state.myConversionChart.init = 0
  },
  [MYCONVERSIONCHART_INIT_SUCCESS](state, data) {
    const { myConversionChart } = state
    myConversionChart.menu = data.menu
    myConversionChart.init = 1
    myConversionChart.lastUpdated = new Date()
    myConversionChart.scope = data.scope
    myConversionChart.appId = data.appId
    myConversionChart.info = data.info
    myConversionChart.appIds = data.appIds
    Vue.set(myConversionChart, 'chartInfo', data.chartInfo)
  },
  [MYCONVERSIONCHART_INIT_FAIL](state) {
    state.myConversionChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
